import { enumToTitleCase } from '../utils/formatting';
import type { DisplayEnum } from '.';
import { convertToDisplayEnum, makeConfig } from './utils';

// Templates
export type BrightlineTemplate = keyof typeof brightlineTemplateDisplayNames;

const brightlineTemplateDisplayNames = {
  DYNAMIC_ADDRESSABLE: enumToTitleCase,
  MAX_SELECTOR: enumToTitleCase,
  EXPANDABLE: enumToTitleCase,
  INSTREAM_INTERACTIVE: enumToTitleCase,
  GATEWAY_SHOP: enumToTitleCase,
  TEST_BRIGHTLINE: enumToTitleCase,

  // @deprecated
  AD_SELECTOR: enumToTitleCase,
  GATEWAY_GO: enumToTitleCase,
};

export const brightlineTemplates = makeConfig<BrightlineTemplate>(brightlineTemplateDisplayNames);
export const brightlineTemplateKeys = Object.keys(brightlineTemplates) as BrightlineTemplate[];

export function convertBrightlineTemplate(apiValue: string): DisplayEnum<BrightlineTemplate> {
  return convertToDisplayEnum(apiValue, brightlineTemplates);
}

// Feature List
export type BrightlineFeature = keyof typeof brightlineFeatureDisplayNames;

const brightlineFeatureDisplayNames = {
  IN_STREAM_SCROLLABLE: enumToTitleCase,
  IN_STREAM_STORE_LOCATOR: enumToTitleCase,
  IN_STREAM_DIAGNOSTIC: enumToTitleCase,
  IN_STREAM_QUIZ: enumToTitleCase,
  CTFS_GALLERY_IMAGES: 'CTFS Gallery Images',
  CTFS_GALLERY_VIDEOS: 'CTFS Gallery Videos',
  CTFS_GALLERY_VIDEOS_INFO: 'CTFS Gallery Videos Info',
  REQUEST_FOR_INFO: enumToTitleCase,
  T_COMMERCE: enumToTitleCase,
  STANDARD_VIDEO_2: enumToTitleCase,
  STANDARD_VIDEO_3: enumToTitleCase,
  INTERACTIVE_VIDEO_2: enumToTitleCase,
  INTERACTIVE_VIDEO_3: enumToTitleCase,
};

export const brightlineFeatures = makeConfig<BrightlineFeature>(brightlineFeatureDisplayNames);
export const brightlineFeatureKeys = Object.keys(brightlineFeatures) as BrightlineFeature[];

export function convertBrightlineFeature(apiValue: string): DisplayEnum<BrightlineFeature> {
  return convertToDisplayEnum(apiValue, brightlineFeatures);
}
